import { DateTime } from "luxon";
import { ReactElement } from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";
import z from "zod";

import DateRangePicker, { DateRangePickerProps } from "../DateRangePicker";

export const DateTimeSchema = z.custom<DateTime>(
  value => value instanceof DateTime
);

export const DateRangeSchema = z
  .object({
    startDate: DateTimeSchema,
    endDate: DateTimeSchema,
  })
  .refine(
    ({ startDate, endDate }) => startDate.toMillis() <= endDate.toMillis(),
    { message: "End date cannot be before start date" }
  );

export function RhfDateRangePicker<T extends FieldValues>({
  shortcuts,
  label,
  fullWidth,
  control,
  rules,
  shouldUnregister,
  name,
  secondary,
  minDate,
  maxDate,
}: Omit<DateRangePickerProps, "value" | "onChange"> &
  UseControllerProps<T>): ReactElement {
  const { field, fieldState } = useController({
    control,
    rules,
    shouldUnregister,
    name,
  });

  return (
    <DateRangePicker
      shortcuts={shortcuts}
      label={label}
      fullWidth={fullWidth}
      secondary={secondary}
      value={field.value}
      onChange={field.onChange}
      minDate={minDate}
      maxDate={maxDate}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
    />
  );
}
